module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_03@3x-74f33ad07d194593aad7f9f9da7f26a3.webp";